import React, { useRef } from 'react';
import { useInterceptor } from './PassportClickContext';

export interface PassportClickInterceptorProps {
  children: React.ReactNode;
}

export const PassportClickInterceptor: React.FC<PassportClickInterceptorProps> = ({ children }) => {
  const { enabled, setShowLeaveModal, setPendingLeaveTarget } = useInterceptor();
  const isSyntheticClick = useRef(false);

  const handleCapture = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const path = ((e.nativeEvent as any).composedPath?.() as EventTarget[]) || [];
    const clickedElement = e.target as HTMLElement;

    if (isSyntheticClick.current) {
      isSyntheticClick.current = false;
      return;
    }
    if (!enabled) return;

    const insideAllowed = path.some(
      (node) => node instanceof HTMLElement && node.hasAttribute('data-leave-modal-content')
    );
    if (insideAllowed) return;

    setPendingLeaveTarget(clickedElement);
    e.preventDefault();
    e.stopPropagation();
    setShowLeaveModal(true);
  };

  return (
    <div className="passport-click-capture" onClickCapture={handleCapture}>
      {children}
    </div>
  );
};
